import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import './Selic40Anos.scss';

class Selic40Anos extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();
	}

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Selic 40 anos - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home selic-40-anos-home page-gradient page-gradient--yellow bg-gray" ref="selic-40-anos-home">

          <section className="iniciativas-area selic-40-anos-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink to="/estrategias/para-o-mercado" className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">Selic 40 anos</h1>
                        </div>
                        <div className="card__content__body">
                          <p>O Selic (Sistema Especial de Liquidação e de Custódia) completou 40 anos: somos responsáveis por apoiar o Banco Central na operacionalização do sistema a partir de um convênio com a autarquia, em uma das parcerias público-privadas de maior sucesso no Brasil. Para comemorar a data, foi lançado o primeiro documentário da Associação, que conta essa história, os grandes marcos nas últimas quatro décadas e traz entrevistas com importantes personagens dessa jornada. Confira:  <a href="http://selic40.anbima.com.br/" target="_blank" className="text_link text_link--yellow">selic40.anbima.com.br</a> </p>
													<p>Um dos pilares do Sistema Financeiro Nacional, o Selic faz o registro e a liquidação dos títulos públicos do Tesouro Nacional, além de calcular a taxa Selic diária com base nas operações de financiamento. O sistema bateu o recorde de 100% de disponibilidade durante todo o ano de 2019. Foram processados 1.325 leilões de títulos públicos, com uma média de 23 mil operações de compra e venda de papéis por dia. </p>
													<p>Essa movimentação foi feita por 470 instituições, entre bancos, cooperativas de crédito, corretoras e distribuidoras de valores mobiliários. Elas são responsáveis por 176 mil clientes que mantêm títulos no Selic sem intermédio do Tesouro Direto, como fundos de investimento, de previdência, entre outros. No total, há mais de R$ 6,6 trilhões de papéis em custódia.</p>
                          
                        </div>
                      </div>
                      {/* <div className="card__image">
                        <img src={images.iniciativas.raio_x.capa} />
                      </div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="selic-40-anos-body">

            <div className="container container--large">
              <div className="row">
								
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--no-border">
                      <div className="card__content card__content--full">

                        <div className="card__content__header">
													<h3 className="title title--small yellow">Veja as principais atividades do ano:</h3>
												</div>

												<ul className="bullets bullets--yellow">
													<li><strong>Registros e gravames:</strong> a Circular 3.594 do BC alterou o regulamento do Selic e implementou a função de registro de ônus e gravames, ou seja, quando um título público é dado como garantia em outra operação, essa informação passa a ser gravada no sistema. A mudança era uma demanda antiga do mercado. A partir de uma sugestão nossa, o Selic passou a permitir a emissão de uma certidão pública do contrato de garantia dos papéis;<br /><br /></li>

													<li><strong>Substituição dos mainframes:</strong> trocamos os computadores de grande porte (chamados de mainframes) que executam diariamente o Selic por outros mais rápidos e modernos. A novidade contribui para garantir a plena disponibilidade do sistema;<br /><br /></li>

													<li className="gri_text"><strong>Cibersegurança:</strong> colocamos em prática um programa de conscientização dos funcionários para garantir a segurança da informação – eles passaram por treinamentos de segurança cibernética, como ações de phishing (envio de links por e-mail, passando-se por uma fonte confiável, para obter informações confidenciais de quem recebe), entre outros. Também foi contratada uma empresa que monitora possíveis ameaças de invasão ou vazamento online de dados do sistema, para atuar de forma proativa, antes que algum ataque aconteça. <span className="gri_label light-gray">GRI <b>203-2</b></span></li>
												</ul>

                      </div>
                    </div>
                  </Fade>
                </div>

              </div>
            </div>

          </section>

        </div>
      </div>
    );
  }
}

export { Selic40Anos };
